import {useMemo} from 'react';

import {useGetUsersQuery} from '@dms/api/customer';
import {UserStateFilterSchema} from '@dms/api/shared';

import {getUserName} from '../utils/getUserName';
import {useUserAbsenceIndicators} from './useUserAbsenceIndicators';

type UseGetUserOptionsParams = {
  withAvailabilitySummary?: boolean;
};

export function useGetUserOptions(params?: UseGetUserOptionsParams) {
  const withAvailabilitySummary = params?.withAvailabilitySummary ?? true;
  const {data: users, isLoading} = useGetUsersQuery({
    stateFilter: UserStateFilterSchema.enum.active,
  });
  const {getStatusIndicator, isLoading: isIndicatorsLoading} = useUserAbsenceIndicators({
    isEnabled: withAvailabilitySummary,
  });

  const userOptions = useMemo(
    () =>
      users
        ?.filter((user) => !user.blocked)
        .map((user) => ({
          label: getUserName(user) ?? '',
          value: user.id,
          statusIndicator: withAvailabilitySummary ? getStatusIndicator(user.id) : undefined,
        })) ?? [],
    [users, getStatusIndicator, withAvailabilitySummary]
  );

  return {
    userOptions,
    isLoading: isLoading || isIndicatorsLoading,
  };
}
